'use client';

import { FC, ReactNode } from 'react';

import { EmptyNavigation } from '@telialt/core-navigation/src/components/EmptyNavigation';

import { BranchInfoFooter } from './BranchInfoFooter';
import { Footer } from './Footer';
import { NavBar } from './NavBar';
import { PageActions } from './PageActions';

type Props = {
    dataTest?: string;
    hasEmptyNavBar?: boolean;
    children: ReactNode;
};

export const Layout: FC<Props> = ({ dataTest, hasEmptyNavBar, children }) => {
    return (
        <div data-test={dataTest}>
            {hasEmptyNavBar ? <EmptyNavigation /> : <NavBar />}
            <main id="main-content">{children}</main>
            <PageActions />
            <Footer />
            <BranchInfoFooter />
        </div>
    );
};
